import { selectLoggingOut } from '../../store/auth/selectors';
import { useDispatch, useSelector } from '../../store/store';
import { setLogOutModal } from '../../store/auth/slice';
import { LogOutSquareIcon } from '../../assets/icons';
import { logOutThunk } from '../../store/auth/thunks';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

export default function LogOut() {
    const dispatch = useDispatch();
    const isLoading = useSelector(selectLoggingOut);

    const confirmLogOut = () => {
        dispatch(logOutThunk())
    };

    return (
        <Modal
            size='sm'
            title='Sign out'
            icon={<LogOutSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setLogOutModal(false))}
        >
            <span className={styles.text}>Are you sure you want to sign out ?</span>
            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setLogOutModal(false))}
                />
                <Button
                    type='Error'
                    text='Sign out'
                    loading={isLoading}
                    onClick={confirmLogOut}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
